import { createCmgSimulatorGed } from '../calculators/cmg_simulator_ged';

window.CmgSimulatorGed = undefined;
document.addEventListener('turbo:load', function() {
  const gedCmgSimulatorElement = document.getElementById('paje-simulator-ged');

  if (gedCmgSimulatorElement) {
    window.CmgSimulatorGed = createCmgSimulatorGed();
  }
});
